// Branded SVG fallback for images that fail to load.
// Returns a data: URL so it can be used directly in <img src>.
export function placeholderSvg(label = "Project Photo") {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 600">
  <defs>
    <linearGradient id="bg" x1="0" x2="1" y1="0" y2="1">
      <stop offset="0" stop-color="#172033"/>
      <stop offset="1" stop-color="#0f172a"/>
    </linearGradient>
    <pattern id="dot" width="22" height="22" patternUnits="userSpaceOnUse">
      <circle cx="1.2" cy="1.2" r="1.2" fill="#ffffff" fill-opacity="0.06"/>
    </pattern>
  </defs>
  <rect width="800" height="600" fill="url(#bg)"/>
  <rect width="800" height="600" fill="url(#dot)"/>
  <g transform="translate(400 270)" fill="#eab308">
    <path d="M-32 -28 l8 -8 l28 28 l-8 8 z M-44 -16 a14 14 0 1 1 16 -16 l4 4 a10 10 0 1 0 -12 12 z" fill="#eab308" opacity="0.9"/>
  </g>
  <text x="400" y="360" text-anchor="middle" fill="#ffffff" font-family="'Plus Jakarta Sans', system-ui, sans-serif" font-size="32" font-weight="800">${label}</text>
  <text x="400" y="392" text-anchor="middle" fill="#ffffff" fill-opacity="0.55" font-family="'Plus Jakarta Sans', system-ui, sans-serif" font-size="16">Real project photo coming soon</text>
</svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}
